import { Capacitor } from "@capacitor/core"

export async function confirmAction({
	title,
	message
}: {
	title: string
	message: string
}) {
	if (!Capacitor.isNativePlatform()) return window.confirm(message)

	const { Dialog } = await import("@capacitor/dialog")
	const { value } = await Dialog.confirm({ title, message })
	return value
}
